import { inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';
import { DeviceSizeService } from './device-size.service';

export const provideDeviceSize = () =>
    makeEnvironmentProviders([DeviceSizeService, provideEnvironmentInitializer(() => inject(DeviceSizeService))]);
